import { IxEnv } from "@sdk/shared/types/sdk.types";

export const AUTH_COOKIE_NAME = "ix_auth";
export const ADMIN_AUTH_COOKIE_NAME = (env: IxEnv) => "ix_admin_auth" + env;
